

var _ = require('underscore');
var sprintf = require('js/vendor/sprintf');

module.exports = {
  link(text, href, ...args) {
    var linkArgs;
    var numPlaceholders;

    if (arguments.length < 2) {
      throw new Error('At least 2 arguments are mandatory');
    }

    numPlaceholders = _.countBy(text, (el) => el === '%');

    if (process.env.NODE_ENV !== 'production' && numPlaceholders.true !== args.length + 2) {
      console.warn('Number of placeholders and extra arguments do not match');
    }

    linkArgs = ['<a href="' + href + '">', '</a>'];
    return sprintf.apply(null, [text].concat(linkArgs).concat(args));
  },

  pluralize(text, pluralText, num, ...args) {
    var numPlaceholders;
    var argNumbers = [num].concat(args);

    if (arguments.length < 3) {
      throw new Error('At least 3 arguments are mandatory');
    }

    if (typeof num !== 'number') {
      throw new Error('The third parameter should be a number to choose the single or plural form');
    }

    if (num === 1) {
      numPlaceholders = (text.match(/%/g) || []).length;

      if (!numPlaceholders) {
        return text;
      } else {
        if (process.env.NODE_ENV !== 'production' && numPlaceholders !== argNumbers.length) {
          console.warn('Number of placeholders and extra arguments do not match', text, argNumbers);
        }

        return sprintf.apply(null, [text].concat(argNumbers));
      }
    } else {
      numPlaceholders = (pluralText.match(/%/g) || []).length;
      if (!numPlaceholders) {
        return pluralText;
      } else {
        if (process.env.NODE_ENV !== 'production' && numPlaceholders !== argNumbers.length) {
          console.warn('Number of placeholders and extra arguments do not match', '"' + pluralText + '"');
        }

        return sprintf.apply(null, [pluralText].concat(argNumbers));
      }
    }
  },

  sprintf(text, ...args) {
    var numPlaceholders = (text.match(/%/g) || []).length;

    if (!numPlaceholders) {
      return text;
    } else {
      if (numPlaceholders !== args.length) {
        console.warn('Number of placeholders and extra arguments do not match', text, args);
      }

      return sprintf.apply(null, [text].concat(args));
    }
  },
};



// WEBPACK FOOTER //
// ./app/assets/js/i18nUtils.js